<h2 mat-dialog-title>Environment Information</h2>
<mat-dialog-content>
	<div class="env-info">
		<div class="info-section">
			<h3>Application</h3>
			<div class="info-row">
				<span class="info-label">Version:</span>
				<span class="info-value">{{ data.version }}</span>
			</div>
			<div class="info-row">
				<span class="info-label">Environment:</span>
				<span class="info-value">{{ data.environment }}</span>
			</div>
		</div>

		<div class="info-section">
			<h3>Notifications</h3>
			<div class="info-row">
				<span class="info-label">Permission:</span>
				<span class="info-value"
					[class.granted]="data.notificationPermission === 'granted'"
					[class.denied]="data.notificationPermission === 'denied'">
					{{ data.notificationPermission }}
				</span>
			</div>
			<div class="info-row">
				<span class="info-label">FCM Token:</span>
				<span class="info-value token-value">{{ data.fcmToken }}</span>
			</div>
			<div class="info-row test-button-row">
				<button
					mat-raised-button
					color="primary"
					(click)="sendTestNotification()"
					[disabled]="isSendingTest || data.notificationPermission !== 'granted'">
					<mat-icon *ngIf="!isSendingTest">send</mat-icon>
					<mat-spinner *ngIf="isSendingTest" diameter="20" style="display: inline-block;"></mat-spinner>
					{{ isSendingTest ? 'Sending...' : 'Send Test Notification' }}
				</button>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>